// extracted by mini-css-extract-plugin
export default {"topoffer":"TopOffer_topoffer__zWxGc","offerdiv":"TopOffer_offerdiv__50Foy","offerbutton":"TopOffer_offerbutton__sh0q9","para":"TopOffer_para__CBSJz"};